<template>
  <div>
  <Menu></Menu>
    <main>
        <div class=" d-flex w-100 h-100 p-5 mx-auto flex-column">
            <div class="container">
                  <div class="row">
                      <div class="col-md-6 descargar-app">
                          <h1 class="text-green">
                            <span v-text="descargaApp"></span></h1>
                            <h1 class="text-black">y realiza tus <span>cambios</span>
                            <br> donde sea que <br>te <span>encuentres</span></h1>
                            
                            <div class="d-flex pt-3">
                                <a class="flex-shrink-0 me-2" @click="grabarAndroid" href="https://play.google.com/store/apps/details?id=com.futuromovil.kallpacambios" target="_blank"><img src="@/assets/img/android.png" alt=""  class="app-img"></a>

                                <a class="pb-3 mb-0 lh-sm" @click="grabarIos" href="https://apps.apple.com/ec/app/kallpa-cambios/id1593803538" target="_blank"><img src="@/assets/img/ios.png" alt="" class="app-img"></a>
                            </div>
                            <p>Todas nuestras aplicaciones funcionan también fuera del Perú.</p>
                      </div>
                      <div class="col-md-6">
                          <img class="d-flex me-auto m-app" src="@/assets/img/fotos.png" alt="cambiar dolar">
                      </div>
                  </div>
            </div> 
        </div>
    </main>
  <footer class=" text-white">
    <div class="container">
        <div class="col-lg-12 footer ">
            <div class="row">
                <div class="col-md-5">
                    <img src="@/assets/img/logo-vertical.png" alt="" width="250">
                     <p>Un servicio de Kallpa Securities S.A.B.</p>
                    <p>RUC: 20492942121</p>

                </div>
                <div class="col-md-4">
                    <h4>Síguenos en:</h4>
                    <a href="https://facebook.com/kallpasablima" target="_blank"><i class="fab fa-facebook-square"></i> @Kallpasablima</a> <br>
                    <a href="https://www.instagram.com/kallpasab/" target="_blank"><i class="fab fa-instagram"></i> @kallpasab</a> <br>
                    <a href="https://twitter.com/KallpaSAB" target="_blank"><i class="fab fa-twitter-square"></i> @KallpaSAB</a> <br>
                    <a href="https://www.linkedin.com/company/kallpa-educa/?viewAsMember=true" target="_blank"><i class="fab fa-linkedin"></i> @KallpaSAB</a>
                    <p></p>
                    <p><a  @click="$router.push('/Reclamos').catch(err => {})"><img src="@/assets/img/LibRec.png" alt="reclamo" width="50"> Libro de Reclamaciones</a></p>
                </div>
                <div class="col-md-3">
                    <h4 class="cnt">Contáctanos</h4>
                    <ul class="list-footer">
                        <li><i class="fas fa-phone"></i> 630-7500 Anexo 195</li>
                        <li><i class="fas fa-mobile-alt"></i> 940131392</li>
                        <li><i class="fas fa-envelope"></i> clientes@kallpacambios.com</li>
                        <li><i class="fas fa-map-marker-alt"></i>Jr. Monterosa 233 oficina 902,Chacarilla del Estanque, Santiago de Surco.</li>
                        <li>Horario de atención: {{horaInicio}} - {{horaFin}}</li>
                    </ul>
            </div>
            </div>
        </div>
        <hr>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2021. Kallpa Securities Sociedad Agente de Bolsa // Kallpa Cambios. Todos los derechos reservados. </p>
                <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>
  </div>
</template>

<script>

import auth from '@/services/auth'
import helpers from '@/services/helpers'

import Menu from "@/layouts/Menu";

import Vue from 'vue';




export default {
  name: "Descargas",
  
  components: {
    Menu,
  },
  data() {
    return {
      horaInicio:"",
      horaFin:"",
      descargaApp:"",
      disabled: true,
      showModal: true,
      preguntaFrec:[],
      urlPoliticasSeguridad:'',
      urlTerminosCondiciones:'',
    };
  },
  beforeCreate() {
    helpers.actualizarTipoCambio(this);
    window.scrollTo(0, 0);
    auth.listParameters().then(response => {
          this.numeroContacto=response.ParametrosGenerales.find(e=>e.Id=="NUKA0001").ValorParametroValor;
          this.horaInicio=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").ValorParametroValor;
          this.horaFin=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").ValorParametroValor;
          this.preguntaFrec=response.ParametrosGenerales.filter(e=>e.IdParametro=="PRFR");
          this.urlTerminosCondiciones = response.ParametrosGenerales.find(e=>e.Id == "MENS0006").DetalleParametroValor;
          this.urlPoliticasSeguridad = response.ParametrosGenerales.find(e=>e.Id == "MENS0007").DetalleParametroValor;
          this.descargaApp=response.ParametrosGenerales.find(e=>e.Id=="TITU0006").NombreParametroValor;
    });
    
  },

methods: {
    grabarAndroid(){
      auth.registerContador(this.$route.query.direccion,"android")
    },
    grabarIos(){
      auth.registerContador(this.$route.query.direccion,"ios")
    },
},

mounted() {


  
  },
 
};
</script>





// WEBPACK FOOTER //
// src/components/pages/Descargas.vue